// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/report_builder_2_reports" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportBuilder2Reports } from "./constants";
import type { EngagementReportBuilder2ReportsParams, EngagementReportBuilder2ReportsResult } from "./types";

export const getDataTableEngagementReportBuilder2Reports = reactQueryTableFetcherAdapter(
  engagementReportBuilder2Reports,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: EngagementReportBuilder2ReportsParams
  ): Promise<EngagementReportBuilder2ReportsResult> => {
    return fetch(
      "/engagement/report_builder_2_reports",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
